export enum CreateForumTopicDialogType {
  General = 'General',
  Supplier = 'Supplier',
  Product = 'Product',
}
